import { render, staticRenderFns } from "./TypeEdit.vue?vue&type=template&id=b921cf90&scoped=true"
import script from "./TypeEdit.vue?vue&type=script&lang=js"
export * from "./TypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b921cf90",
  null
  
)

export default component.exports